import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Dialog, Typography, Button, DialogContent } from '@material-ui/core'
import { Button as StyledButton } from '../Kit/Buttons'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles/dialog.styles'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import {
  setTermsAndConditionsAccepted,
  selectTermsAndConditionsAccepted,
} from '../../reducers/callSlice'
import { ButtonContainer, Link } from './style'
import { TermsAndConditionsIcon } from '../../assets/svg/TermsAndConditionsIcon'
import { usePostHogAnalytics } from '@gojiraf/analytics'
import { useEvent } from '../../hooks/useEvent'

const { REACT_APP_TYC_URL } = process.env

const useStyles = makeStyles((theme) => styles(theme))

export const TermsAndConditions = ({ customTermsAndConditions }) => {
  const { close } = useEvent()
  const { postHogTrackEvent } = usePostHogAnalytics()
  const termsAndConditionsAccepted = useSelector(selectTermsAndConditionsAccepted)
  const [isOpen, setIsOpen] = useState(true)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const classes = useStyles()

  const acceptTermsAndConditions = () => {
    setIsOpen(false) // Cerrar inmediatamente
    postHogTrackEvent('event-accept-tyc')
    dispatch(setTermsAndConditionsAccepted(true))
  }

  const rejectTermsAndConditions = () => {
    close('USER REJECTED TERMS AND CONDITIONS')
  }

  const handleClickReadTermsAndConditions = () => {
    postHogTrackEvent('event-click-tyc')
  }

  const getTermsAndConditionsWithLink = (text) => {
    const textToLink = t('dialogs.termsAndConditionsBrTitle')
    const [firstPieceOfText, secondPieceOfText] = text.split(textToLink)

    return (
      <div>
        {firstPieceOfText}
        <Link
          href={customTermsAndConditions.active ? customTermsAndConditions.url : REACT_APP_TYC_URL}
          target="_blank"
          rel="noreferrer"
          onClick={handleClickReadTermsAndConditions}
          id="read-terms-and-conditions-br"
          data-test="read-terms-and-conditions-br"
        >
          {textToLink}
        </Link>
        {secondPieceOfText}
      </div>
    )
  }
  return (
    <StyledDialog
      BackdropProps={{ style: { backgroundColor: 'transparent', backdropFilter: 'blur(4px)' } }}
      aria-labelledby="simple-dialog-title"
      open={!termsAndConditionsAccepted && isOpen}
      id="terms-and-conditions-br"
      data-test="terms-and-conditions"
    >
      <StyledTermIcon />
      <StyledTypography variant="h6" color="primary" align="center">
        {t('dialogs.termsAndConditionsBrTitle')}
      </StyledTypography>
      <StyledTypography variant="subtitle2" color="primary" align="center">
        {getTermsAndConditionsWithLink(t('dialogs.termsAndConditionsBr'))}
      </StyledTypography>
      <DialogContent className={classes.dialog__actions}>
        <ButtonContainer>
          <StyledButton
            variant="contained"
            onClick={acceptTermsAndConditions}
            id="accept-terms-and-conditions-br"
            data-test="accept-terms-and-conditions-br"
          >
            {t('dialogs.acceptButton').toUpperCase()}
          </StyledButton>
          <StyledCloseButton
            onClick={rejectTermsAndConditions}
            id="reject-terms-and-conditions-br"
            data-test="reject-terms-and-conditions-br"
          >
            {t('dialogs.leaveButton').toUpperCase()}
          </StyledCloseButton>
        </ButtonContainer>
      </DialogContent>
    </StyledDialog>
  )
}

TermsAndConditions.propTypes = {
  customTermsAndConditions: PropTypes.object,
}

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    font-size: 12px;
    font-weight: 500;
    align-items: center;
    max-width: 16.938rem;
    max-height: 16.25rem;
    gap: 0.5rem;
    padding: ${({ padding }) => padding || '0.938rem'};
    border-radius: 8px;
    overflow: hidden;
  }
`
const StyledTermIcon = styled(TermsAndConditionsIcon)`
  margin-top: 11px;
`
export const StyledTypography = styled(Typography)`
  font-size: ${({ fontSize }) => fontSize || '1rem'};
  line-height: 16px;
  letter-spacing: 0.2px;
`
const StyledCloseButton = styled(Button)`
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 2px;
`
